import authConfig from '../auth/config';

export const isUserLoggedIn = () => {
    if (localStorage.getItem(authConfig?.storageTokenKeyName)) {
        return true;
    }
    return false;
};
